import { FC, CSSProperties } from 'react';

type EditIconProps = {
  style?: CSSProperties;
  className?: string;
};

const MoveToIcon: FC<EditIconProps> = ({
  style,
  className,
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={ style }
      className={ className }
    >
      <path
        // eslint-disable-next-line max-len
        d="M4.09846 15.3335L4.09846 0.666829M4.09846 0.666829L7.21973 3.76567M4.09846 0.666829L0.99962 3.76566"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        // eslint-disable-next-line max-len
        d="M11.9015 0.666504L11.9015 15.3332M11.9015 15.3332L8.78027 12.2343M11.9015 15.3332L15.0004 12.2343"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MoveToIcon;
